import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ClearableInput from '../clearableInput/ClearableInput';
var TableSearch = function TableSearch(props) {
  var className = props.className;
  var wrapperClassNames = classNames('table-toolbar-search', 'input-group', className && className);
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClassNames
  }, /*#__PURE__*/React.createElement("span", {
    className: "input-group-addon"
  }, /*#__PURE__*/React.createElement("span", {
    className: "rioglyph rioglyph-search"
  })), /*#__PURE__*/React.createElement(ClearableInput, props));
};
TableSearch.defaultProps = {};
TableSearch.propTypes = {
  className: PropTypes.string
};
export default TableSearch;